import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautifully%20styled%20flat%20lay%20of%20diverse%20fashion%20items%20including%20designer%20sneakers%20luxury%20watches%20stylish%20sunglasses%20a%20leather%20handbag%20and%20casual%20clothing%20pieces%20arranged%20on%20a%20light%20cream%20marble%20surface%20with%20warm%20natural%20sunlight%20streaming%20from%20the%20left%20side%2C%20sage%20green%20linen%20fabric%20accents%2C%20minimalist%20European%20aesthetic%20composition%2C%20soft%20shadows%20creating%20depth%2C%20high-end%20editorial%20product%20photography%20with%20organic%20styling%2C%20warm%20neutral%20tones%2C%20terracotta%20and%20cream%20palette&width=1600&height=900&seq=yoybuy-hero-v2&orientation=landscape"
        alt="YOYBUY Spreadsheet — организация покупок из Китая"
        title="YOYBUY Spreadsheet — организация покупок из Китая"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-sm font-medium mb-6 tracking-wide whitespace-nowrap">
          {t('hero.trusted')}
        </span>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 md:mb-6 leading-tight">
          {t('hero.heading')}
        </h1>

        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {t('hero.subheading')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-table-line text-lg w-5 h-5 flex items-center justify-center"></i>
            {t('hero.ctaYoybuy')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-background-50/95 text-foreground-900 font-semibold text-base hover:bg-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-cart-2-line text-lg w-5 h-5 flex items-center justify-center"></i>
            {t('hero.ctaBuyNow')}
          </a>
        </div>

        <div className="mt-10">
          <a
            href="#articles-section"
            className="inline-flex items-center gap-2 text-background-50/70 hover:text-background-50 text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
            {t('nav.shoppingGuide')}
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}